import React, { useContext, useEffect } from 'react';
import { ValidationContext } from '../../providers/ValidationContext';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import StatusEventPayload from '../../services/events/statusEventPayload';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function ValidationStatusScreen(): JSX.Element {
  const { initialized, flowFailed, flowSuccessful } = useContext(FlowConfigContext);
  const { getStatusUnauthenticated } = useContext(ValidationContext);

  const fetchStatus = async () => {
    const statusResult = await getStatusUnauthenticated();
    if (statusResult.isFailed()) {
      flowFailed();
      return;
    }

    const status = statusResult.success();
    flowSuccessful(new StatusEventPayload(status));
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    fetchStatus();
  }, [initialized]);

  return <></>;
}
export default withRouteAnalytics(ValidationStatusScreen, Screens.VALIDATION_STATUS);
